{
  "version": 1,
  "asset_id": "686a9c45-1054-4b7c-890c-42ebcfb22741",
  "project_id": "377c4fbc-40e4-471f-8e12-f87143b2e1e2",
  "url": "/__l5e/assets-v1/686a9c45-1054-4b7c-890c-42ebcfb22741/baridimob.png",
  "r2_key": "a/v1/377c4fbc-40e4-471f-8e12-f87143b2e1e2/686a9c45-1054-4b7c-890c-42ebcfb22741/baridimob.png",
  "original_filename": "baridimob.png",
  "size": 149101,
  "content_type": "image/png",
  "created_at": "2026-07-17T18:00:50Z"
}
